var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-container"},[_c('div',{staticClass:"tab"},[_c('ul',{staticClass:"clearfix"},_vm._l((_vm.tabs),function(item){return _c('li',{key:item.path,class:{ actived: item.selected },on:{"click":function($event){return _vm.clickTab(item)}}},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(item.title)+" ")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }